import { call, takeEvery } from 'redux-saga/effects';
import { formControlActions } from '../formControlSlice';
import { copyBisonAnnouncementHandler } from './copyHandlers/copyBisonAnnouncementHandler';
import { copyAppointmentDataHandler, copyAppointmentDataPartialHandler } from './copyHandlers/copyAppointmentHandlers';
import { copyLocationTransactionHandler, copyLocationTransactionPartialHandler } from './copyHandlers/copyLocationTransactionHandlers';
import { copyConditionalsAutofillHandler } from './copyHandlers/copyConditionalsAutofillHandler';
import { copySheetAnnouncementHandler } from './copyHandlers/copySheetAnnouncementHandler';

class CopyToFormSagas {
    init = () => [
        call(this.fromBisonAnnouncementTable),
        call(this.fromLocationTransactionsTable),
        call(this.fromLocationTransactionsTablePartial),
        call(this.fromAppointmentsTable),
        call(this.fromAppointmentsTablePartial),
        call(this.fromConditionalsAutofill),
        call(this.fromSheetAnnouncementTable),
    ];

    *fromBisonAnnouncementTable() {
        yield takeEvery(formControlActions.copyBisonAnnouncement.type, copyBisonAnnouncementHandler);
    }

    *fromConditionalsAutofill() {
        yield takeEvery(formControlActions.copyConditionalsAutofill.type, copyConditionalsAutofillHandler);
    }

    *fromLocationTransactionsTable() {
        yield takeEvery(formControlActions.copyLocationTransaction.type, copyLocationTransactionHandler);
    }

    *fromLocationTransactionsTablePartial() {
        yield takeEvery(formControlActions.copyLocationTransactionPartial.type, copyLocationTransactionPartialHandler);
    }

    *fromAppointmentsTable() {
        yield takeEvery(formControlActions.copyAppointmentData.type, copyAppointmentDataHandler);
    }

    *fromAppointmentsTablePartial() {
        yield takeEvery(formControlActions.copyAppointmentDataPartial.type, copyAppointmentDataPartialHandler);
    }

    *fromSheetAnnouncementTable() {
        yield takeEvery(formControlActions.copySheetAnnouncement.type, copySheetAnnouncementHandler);
    }
}

export default new CopyToFormSagas();
